<script setup lang="ts">
import { badgeSize, badgeVariants } from './data'
import type { IBadge } from './interfaces'

const props = withDefaults(defineProps<IBadge>(), {
    variant: 'blue',
    size: 'small',
})

const { variant, textColor, backgroundColor, text, size } = props

const checkedVariant = computed(() => (badgeVariants.includes(variant) ? variant : 'blue'))
const checkedSize = computed(() => (badgeSize.includes(size) ? size : 'small'))

const getStyles = computed<string>(() => {
    const tmp: string[] = []
    if (textColor) {
        tmp.push(`color: ${textColor} !important;`)
    }
    if (backgroundColor) {
        tmp.push(`background-color: ${backgroundColor} !important;`)
    }

    return tmp.join(' ')
})
</script>

<template>
    <span
        :class="{
            'bg-plus-lp-dark-blue text-white': checkedVariant === 'blue',
            'bg-plus-lp-lime text-plus-lp-dark-blue': checkedVariant === 'lime',
            'bg-white text-plus-lp-dark-blue': checkedVariant === 'light',
            'px-1 py-[2px] text-lp-label-xs': checkedSize === 'small',
            'px-2 py-1 text-lp-label-sm': checkedSize === 'medium',
        }"
        :style="getStyles"
        class="rounded px-1 py-[2px] text-lp-label-xs font-medium"
    >
        <slot>
            <span
                v-if="text"
                v-html="text"
            />
        </slot>
    </span>
</template>
